<ng-template #buttonContent>
  <ng-content></ng-content>
</ng-template>

@if (variant() === 'primary') {
  <button
    mat-flat-button
    [type]="type()"
    [disabled]="disabled()"
    [class]="'btn-' + variant() + ' btn-' + size()"
    class="inline-flex items-center justify-center transition-all duration-300 font-medium rounded-full active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed"
  >
    <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
  </button>
} @else if (variant() === 'secondary') {
  <button
    mat-stroked-button
    [type]="type()"
    [disabled]="disabled()"
    [class]="'btn-' + variant() + ' btn-' + size()"
    class="inline-flex items-center justify-center transition-all duration-300 font-medium rounded-full active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed"
  >
    <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
  </button>
} @else {
  <button
    mat-button
    [type]="type()"
    [disabled]="disabled()"
    [class]="'btn-' + variant() + ' btn-' + size()"
    class="inline-flex items-center justify-center transition-all duration-300 font-medium rounded-full active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed"
  >
    <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
  </button>
}
